import Breadcrumbs from 'components/Layout/Breadcrumbs/Breadcrumbs';
import { Webline } from 'components/Layout/Webline/Webline';
import SharedWishlist from 'components/Pages/Wishlist/SharedWishlist';
import Wishlist from 'components/Pages/Wishlist/Wishlist';
import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { initServerSideProps, ServerSidePropsType } from 'helpers/InitServerSideProps';
import { getServerSidePropsWrapper } from 'helpers/serverSide/getServerSidePropsWrapper';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { getInternationalizedStaticUrls } from 'utils/getInternationalizedStaticUrls';
import { useGtmStaticPageViewEvent } from 'utils/Gtm/EventFactories';

const WishlistPage: FC<ServerSidePropsType> = () => {
    const { t } = useTranslation();
    const currentDomainConfig = useDomainConfig();

    const [wishlistUrl] = getInternationalizedStaticUrls(['/wishlist'], currentDomainConfig.url);
    const breadcrumbs = [{ name: t('Wishlist'), slug: wishlistUrl }];
    const router = useRouter();
    const urlQueryParamId = router.query.id as string | undefined;
    useGtmStaticPageViewEvent('wishlist', breadcrumbs);

    return (
        <>
            <Webline>
                <Breadcrumbs key="breadcrumb" breadcrumb={breadcrumbs} />
            </Webline>
            <div className="pb-20">
                {urlQueryParamId ? <SharedWishlist urlQueryParamId={urlQueryParamId} /> : <Wishlist />}
            </div>
        </>
    );
};

export const getServerSideProps = getServerSidePropsWrapper(({ domainConfig, redisClient, t }) => async (context) => {
    return initServerSideProps({ context, domainConfig, redisClient, t });
});

export default WishlistPage;
